import {useAppSelector} from "../../store/hooks";
import {ApplicationFormVariant} from "../types/form/ApplicationFormVariant";

export const useApplicationVariant = () => {
    const modalApplicationVariant = useAppSelector((state) => state.mainLead.applicationVariant);

    return modalApplicationVariant ?? ApplicationFormVariant.DEFAULT;
};
import {useAppSelector} from "../../store/hooks";
import {ApplicationFormVariant} from "../types/form/ApplicationFormVariant";

export const useApplicationVariant = () => {
    const modalApplicationVariant = useAppSelector((state) => state.mainLead.applicationVariant);

    return modalApplicationVariant ?? ApplicationFormVariant.DEFAULT;
};
